<template>
  <div class="flex flex-col items-center">
    <svg
      v-if="available"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <circle cx="16" cy="16" r="15" fill="#FFEEF8" stroke="#99005C" stroke-width="2" />
      <g clip-path="url(#clip0_2889_3288)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 12C16.3682 12 16.6667 12.2985 16.6667 12.6667V13.9967C16.6667 14.3649 16.3682 14.6633 16 14.6633C15.6318 14.6633 15.3333 14.3649 15.3333 13.9967V12.6667C15.3333 12.2985 15.6318 12 16 12Z"
          fill="#99005C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.3419 14.3386C10.6023 14.0782 11.0244 14.0782 11.2847 14.3386L12.2314 15.2853C12.4918 15.5456 12.4918 15.9677 12.2314 16.2281C11.9711 16.4884 11.5489 16.4884 11.2886 16.2281L10.3419 15.2814C10.0816 15.0211 10.0816 14.5989 10.3419 14.3386Z"
          fill="#99005C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8 19.9967C8 19.6285 8.29848 19.33 8.66667 19.33H10C10.3682 19.33 10.6667 19.6285 10.6667 19.9967C10.6667 20.3649 10.3682 20.6633 10 20.6633H8.66667C8.29848 20.6633 8 20.3649 8 19.9967Z"
          fill="#99005C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.3333 19.9967C21.3333 19.6285 21.6318 19.33 22 19.33H23.3333C23.7015 19.33 24 19.6285 24 19.9967C24 20.3649 23.7015 20.6633 23.3333 20.6633H22C21.6318 20.6633 21.3333 20.3649 21.3333 19.9967Z"
          fill="#99005C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.6581 14.3386C21.9184 14.5989 21.9184 15.0211 21.6581 15.2814L20.7114 16.2281C20.4511 16.4884 20.0289 16.4884 19.7686 16.2281C19.5082 15.9677 19.5082 15.5456 19.7686 15.2853L20.7153 14.3386C20.9756 14.0782 21.3977 14.0782 21.6581 14.3386Z"
          fill="#99005C"
        />
        <path
          d="M18.6667 19.9967C18.6667 20.3649 18.9651 20.6633 19.3333 20.6633C19.701 20.6633 19.9991 20.3658 20 19.9984C19.9991 19.6309 19.701 19.3333 19.3333 19.3333H18.5829C18.6381 19.5483 18.6667 19.771 18.6667 19.9967Z"
          fill="#99005C"
        />
        <path
          d="M18.8284 17.1682C18.0783 16.4181 17.0609 15.9967 16 15.9967L14.7105 17.6625C15.1018 17.4463 15.5449 17.33 16 17.33C16.7072 17.33 17.3855 17.611 17.8856 18.111C18.2261 18.4516 18.4651 18.8747 18.5829 19.3333H19.3333C19.701 19.3333 19.9991 19.6309 20 19.9984L20 19.9967C20 18.9358 19.5786 17.9184 18.8284 17.1682Z"
          fill="#99005C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.1716 17.1682C13.9217 16.4181 14.9391 15.9967 16 15.9967L14.7105 17.6625C14.4937 17.7823 14.2927 17.9327 14.1144 18.111C13.7739 18.4516 13.5349 18.8747 13.4171 19.3333H18.5829C18.6381 19.5483 18.6667 19.771 18.6667 19.9967C18.6667 20.3649 18.9651 20.6633 19.3333 20.6633C19.701 20.6633 19.9991 20.3658 20 19.9984L20 20C20 20.3682 19.7015 20.6667 19.3333 20.6667H12.6667C12.2985 20.6667 12 20.3682 12 20L12 19.9983L12 19.9967C12 18.9358 12.4214 17.9184 13.1716 17.1682Z"
          fill="#99005C"
        />
      </g>
    </svg>
    <svg v-else aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="15.5" stroke="#6E6F74" />
      <g clip-path="url(#clip0_2889_3273)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 12C16.3682 12 16.6667 12.2985 16.6667 12.6667V13.9967C16.6667 14.3649 16.3682 14.6633 16 14.6633C15.6318 14.6633 15.3333 14.3649 15.3333 13.9967V12.6667C15.3333 12.2985 15.6318 12 16 12Z"
          fill="#6E6F74"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.3419 14.3386C10.6023 14.0782 11.0244 14.0782 11.2847 14.3386L12.2314 15.2853C12.4918 15.5456 12.4918 15.9677 12.2314 16.2281C11.9711 16.4884 11.5489 16.4884 11.2886 16.2281L10.3419 15.2814C10.0816 15.0211 10.0816 14.5989 10.3419 14.3386Z"
          fill="#6E6F74"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8 19.9967C8 19.6285 8.29848 19.33 8.66667 19.33H10C10.3682 19.33 10.6667 19.6285 10.6667 19.9967C10.6667 20.3649 10.3682 20.6633 10 20.6633H8.66667C8.29848 20.6633 8 20.3649 8 19.9967Z"
          fill="#6E6F74"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.3333 19.9967C21.3333 19.6285 21.6318 19.33 22 19.33H23.3333C23.7015 19.33 24 19.6285 24 19.9967C24 20.3649 23.7015 20.6633 23.3333 20.6633H22C21.6318 20.6633 21.3333 20.3649 21.3333 19.9967Z"
          fill="#6E6F74"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.6581 14.3386C21.9184 14.5989 21.9184 15.0211 21.6581 15.2814L20.7114 16.2281C20.4511 16.4884 20.0289 16.4884 19.7686 16.2281C19.5082 15.9677 19.5082 15.5456 19.7686 15.2853L20.7153 14.3386C20.9756 14.0782 21.3977 14.0782 21.6581 14.3386Z"
          fill="#6E6F74"
        />
        <path
          d="M18.6667 19.9967C18.6667 20.3649 18.9651 20.6633 19.3333 20.6633C19.701 20.6633 19.9991 20.3658 20 19.9984C19.9991 19.6309 19.701 19.3333 19.3333 19.3333H18.5829C18.6381 19.5483 18.6667 19.771 18.6667 19.9967Z"
          fill="#6E6F74"
        />
        <path
          d="M18.8284 17.1682C18.0783 16.4181 17.0609 15.9967 16 15.9967L14.7105 17.6625C15.1018 17.4463 15.5449 17.33 16 17.33C16.7072 17.33 17.3855 17.611 17.8856 18.111C18.2261 18.4516 18.4651 18.8747 18.5829 19.3333H19.3333C19.701 19.3333 19.9991 19.6309 20 19.9984L20 19.9967C20 18.9358 19.5786 17.9184 18.8284 17.1682Z"
          fill="#6E6F74"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.1716 17.1682C13.9217 16.4181 14.9391 15.9967 16 15.9967L14.7105 17.6625C14.4937 17.7823 14.2927 17.9327 14.1144 18.111C13.7739 18.4516 13.5349 18.8747 13.4171 19.3333H18.5829C18.6381 19.5483 18.6667 19.771 18.6667 19.9967C18.6667 20.3649 18.9651 20.6633 19.3333 20.6633C19.701 20.6633 19.9991 20.3658 20 19.9984L20 20C20 20.3682 19.7015 20.6667 19.3333 20.6667H12.6667C12.2985 20.6667 12 20.3682 12 20L12 19.9983L12 19.9967C12 18.9358 12.4214 17.9184 13.1716 17.1682Z"
          fill="#6E6F74"
        />
      </g>
    </svg>
    <div v-if="available">
      <span class="text-caption text-primary">Morning</span>
      <span class="sr-only">Available</span>
    </div>
    <div v-else>
      <span class="text-caption text-grey-text-subdued">Morning</span>
      <span class="sr-only">Unavailable</span>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'Morning',
  props: {
    available: { type: Boolean, default: false },
  },
};
</script>
